/* col26 · collection grid with category pills and rule-based filter menus (sections/col26-grid.liquid).
   Same model as the 11.11 deals grid (sale26.js initDeals), standalone so it doesn't depend on the
   campaign script. Cards are drawn once by Liquid; this only hides, shows and re-orders them (CSS
   order), so the store's translation app has nothing to re-scan.

   Filter menus come from the section's "Filter menu" blocks, one "Option = rule, rule" per line:
     tag:X          the product carries tag X (case-insensitive, exact)
     collection:h   the product is in collection h
     product:h      that one product, by handle
     -<rule>        keeps a product out of this option even when another rule matched
     *              whatever no other option in this menu matched
   A menu shows only under its category, and only when two or more of its options hold products. */
(function () {
  'use strict';
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };
  const setText = (n, v) => { if (n && n.textContent !== v) n.textContent = v; };
  const setHidden = (n, h) => { if (n && n.hidden !== h) n.hidden = h; };

  /* ---------- custom dropdown on mouse screens (the select stays, hidden, as the value) ---------- */
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  let uid = 0, open = null, bound = false;
  const split = (t) => { const m = /^(.*?)\s*\((\d[\d,]*)\)\s*$/.exec(t); return m ? [m[1], m[2]] : [t, '']; };
  function syncSelect(sel) {
    const st = sel && sel._c26; if (!st) return;
    const i = sel.selectedIndex, o = sel.options[i];
    setText(st.btn.firstChild, o ? split(o.textContent.trim())[0] : '');
    st.list.querySelectorAll('[role=option]').forEach((li) => { const on = String(+li.dataset.i === i); if (li.getAttribute('aria-selected') !== on) li.setAttribute('aria-selected', on); });
  }
  function enhanceSelect(sel) {
    if (!sel || sel._c26 || !fine.matches) return;
    const field = sel.closest('.c26g__sel'); if (!field) return;
    const id = 'c26g-sel-' + (++uid);
    const lab = field.querySelector('.c26g__sel-l'); if (lab && !lab.id) lab.id = id + '-l';
    const btn = el('button', 'c26g-dd'); btn.type = 'button';
    btn.setAttribute('role', 'combobox'); btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', id);
    const val = el('span', 'c26g-dd__value'); val.id = id + '-v'; btn.appendChild(val);
    if (lab) btn.setAttribute('aria-labelledby', lab.id + ' ' + val.id);
    const list = el('ul', 'c26g-dd__list'); list.id = id; list.setAttribute('role', 'listbox'); list.hidden = true;
    if (lab) list.setAttribute('aria-labelledby', lab.id);
    [...sel.options].forEach((o, i) => {
      const [t, n] = split(o.textContent.trim());
      const li = el('li', 'c26g-dd__opt'); li.setAttribute('role', 'option'); li.id = id + '-' + i; li.dataset.i = i; li.setAttribute('aria-selected', 'false');
      li.appendChild(el('span', 'c26g-dd__label', t));
      if (n) li.appendChild(el('span', 'c26g-dd__count', n));
      const ck = el('span', 'c26g-dd__check'); ck.innerHTML = CHECK; li.appendChild(ck);
      list.appendChild(li);
    });
    sel.classList.add('c26g-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    sel.before(btn); btn.after(list);
    const st = sel._c26 = { sel, btn, list, field, active: -1, typed: '', at: 0 };
    syncSelect(sel);
    const setActive = (i, scroll) => {
      st.active = i;
      [...list.children].forEach((li) => li.classList.toggle('is-active', +li.dataset.i === i));
      const li = list.children[i];
      if (li) { btn.setAttribute('aria-activedescendant', li.id); if (scroll) li.scrollIntoView({ block: 'nearest' }); }
    };
    const close = () => { list.hidden = true; list.classList.remove('is-in'); btn.setAttribute('aria-expanded', 'false'); btn.removeAttribute('aria-activedescendant'); field.classList.remove('is-open'); if (open === st) open = null; };
    const show = () => {
      if (open && open !== st) open.close();
      syncSelect(sel); open = st;
      list.hidden = false; btn.setAttribute('aria-expanded', 'true'); field.classList.add('is-open');
      list.removeAttribute('data-up'); list.removeAttribute('data-align');
      const r = field.getBoundingClientRect(), h = Math.min(list.scrollHeight, 340), below = innerHeight - r.bottom;
      if (below < h + 16 && r.top > below) list.setAttribute('data-up', '');
      if (r.left + list.getBoundingClientRect().width > document.documentElement.clientWidth - 12) list.setAttribute('data-align', 'end');
      setActive(sel.selectedIndex, true);
      if (!reduced) { list.classList.remove('is-in'); void list.offsetWidth; list.classList.add('is-in'); }
    };
    st.close = close;
    const pick = (i) => { if (sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); } syncSelect(sel); };
    btn.addEventListener('click', (e) => { e.preventDefault(); open === st ? close() : show(); });
    list.addEventListener('mousedown', (e) => { if (e.target.closest('[role=option]')) e.preventDefault(); });
    list.addEventListener('click', (e) => { e.preventDefault(); const li = e.target.closest('[role=option]'); if (!li) return; pick(+li.dataset.i); close(); btn.focus({ preventScroll: true }); });
    list.addEventListener('mousemove', (e) => { const li = e.target.closest('[role=option]'); if (li && +li.dataset.i !== st.active) setActive(+li.dataset.i, false); });
    btn.addEventListener('keydown', (e) => {
      const isOpen = open === st, n = list.children.length;
      const move = (to) => { e.preventDefault(); if (!isOpen) show(); setActive(Math.max(0, Math.min(n - 1, to)), true); };
      if (e.key === 'ArrowDown') return isOpen ? move(st.active + 1) : (e.preventDefault(), show());
      if (e.key === 'ArrowUp') return isOpen ? move(st.active - 1) : (e.preventDefault(), show());
      if (e.key === 'Home' && isOpen) return move(0);
      if (e.key === 'End' && isOpen) return move(n - 1);
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!isOpen) return show(); if (st.active > -1) pick(st.active); return close(); }
      if (e.key === 'Escape' && isOpen) { e.preventDefault(); e.stopPropagation(); return close(); }
      if (e.key === 'Tab' && isOpen) return close();
      if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const now = Date.now(); st.typed = (now - st.at > 700 ? '' : st.typed) + e.key.toLowerCase(); st.at = now;
        const h = [...sel.options].findIndex((o) => o.textContent.trim().toLowerCase().startsWith(st.typed));
        if (h < 0) return; e.preventDefault(); if (isOpen) setActive(h, true); else pick(h);
      }
    });
    if (!bound) {
      bound = true;
      document.addEventListener('pointerdown', (e) => { if (open && !open.field.contains(e.target)) open.close(); }, true);
      addEventListener('resize', () => { if (open) open.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) { const st = open; st.close(); st.btn.focus({ preventScroll: true }); } });
    }
  }

  /* ---------- the grid ---------- */
  function init(root) {
    if (root.dataset.c26Ready) return; root.dataset.c26Ready = '1';
    const grid = root.querySelector('[data-g-grid]'); if (!grid) return;
    const items = [...grid.querySelectorAll('[data-g-item]')].map((li) => ({
      li, i: +li.dataset.i, h: li.dataset.h || '', cats: li.dataset.cats || '|', tags: li.dataset.tags || '||', cols: li.dataset.cols || '||',
      price: +li.dataset.price || 0, off: +li.dataset.off || 0, date: +li.dataset.date || 0, name: li.dataset.title || '', fac: []
    }));
    const pills = [...root.querySelectorAll('[data-g-cat]')];
    const pillRow = root.querySelector('[data-g-cats]');
    const sels = {}; root.querySelectorAll('[data-g-sel]').forEach((x) => { sels[x.dataset.gSel] = x; });
    const more = root.querySelector('[data-g-more]'), empty = root.querySelector('[data-g-empty]'), count = root.querySelector('[data-g-count]');
    const box = root.querySelector('[data-g-facets-box]');
    const size = Math.max(1, +root.dataset.page || 20);
    const sortDefault = sels.sort ? (sels.sort.dataset.default || '') : '';
    const st = { cat: '', price: '', sort: sortDefault, f: {} };
    let pages = 1;

    let facets = [];
    try { facets = JSON.parse(root.querySelector('[data-g-facets]').textContent) || []; } catch (e) {}
    facets = facets.map((f) => ({
      cat: String(f.cat || '').trim().toLowerCase(), label: f.label || '', all: f.all || f.label || '',
      opts: String(f.options || '').split('\n').map((ln) => {
        const k = ln.indexOf('='); if (k < 1) return null;
        const rules = ln.slice(k + 1).split(',').map((r) => r.trim().toLowerCase()).filter(Boolean).map((r) => {
          const neg = r.charAt(0) === '-'; if (neg) r = r.slice(1).trim();
          if (r === '*') return { t: 'rest', neg: false };
          const c = r.indexOf(':'); if (c < 1) return null;
          const t = r.slice(0, c).trim(), v = r.slice(c + 1).trim();
          if (!v || !/^(tag|collection|product)$/.test(t)) return null;
          return { t, v: t === 'product' ? v : '|' + v + '|', neg };
        }).filter(Boolean);
        return { label: ln.slice(0, k).trim(), rules };
      }).filter((o) => o && o.label && o.rules.length)
    })).filter((f) => f.opts.length);
    const hit = (x, r) => r.t === 'tag' ? x.tags.includes(r.v) : r.t === 'collection' ? x.cols.includes(r.v) : r.t === 'product' ? x.h === r.v : false;
    items.forEach((x) => {
      x.fac = facets.map((f) => {
        let on = f.opts.reduce((a, o, k) => (o.rules.some((r) => !r.neg && r.t !== 'rest' && hit(x, r)) && !o.rules.some((r) => r.neg && hit(x, r)) ? a.concat(k) : a), []);
        if (!on.length) on = f.opts.reduce((a, o, k) => (o.rules.some((r) => r.t === 'rest') ? a.concat(k) : a), []);
        return new Set(on);
      });
    });

    /* category pills: count, drop the empty ones; with one category left there is nothing to choose,
       so the row hides and that category's menus show straight away */
    const catOf = (b) => b.dataset.gCat;
    const inCat = (x) => !st.cat || x.cats.includes('|' + st.cat + '|');
    const live = pills.filter((b) => {
      const c = catOf(b), n = items.filter((x) => !c || x.cats.includes('|' + c + '|')).length;
      setText(b.querySelector('[data-g-catn]'), String(n));
      if (c && !n) { b.hidden = true; return false; }
      return !!c;
    });
    if (!live.length) setHidden(pillRow, true);
    else if (live.length === 1 && items.every((x) => x.cats.includes('|' + catOf(live[0]) + '|'))) { setHidden(pillRow, true); st.cat = catOf(live[0]); }
    const catLabel = (c) => { const b = pills.find((p) => catOf(p) === c); const t = b && (b.querySelector('span') || b); return t ? t.textContent.trim().toLowerCase() : ''; };

    function buildFacets() {
      if (!box) return;
      box.textContent = ''; st.f = {};
      const lab = catLabel(st.cat), pool = items.filter(inCat);
      facets.forEach((f, fi) => {
        if (f.cat && f.cat !== lab) return;
        const n = f.opts.map((o, k) => pool.filter((x) => x.fac[fi].has(k)).length);
        if (n.filter((c) => c > 0).length < 2) return;
        const wrap = el('label', 'c26g__sel'); wrap.appendChild(el('span', 'c26g__sel-l', f.label));
        const sel = el('select'); sel.appendChild(new Option(f.all, ''));
        f.opts.forEach((o, k) => { if (n[k]) sel.appendChild(new Option(o.label + ' (' + n[k] + ')', String(k))); });
        sel.addEventListener('change', () => { if (sel.value === '') delete st.f[fi]; else st.f[fi] = +sel.value; pages = 1; apply(); });
        wrap.appendChild(sel); box.appendChild(wrap); enhanceSelect(sel);
      });
    }
    function apply() {
      let lo = 0, hi = Infinity;
      if (st.price) { const [a, b] = st.price.split('-'); lo = +a || 0; hi = b === '' ? Infinity : +b; }
      const fk = Object.keys(st.f);
      const list = items.filter((x) => inCat(x) && x.price >= lo && x.price < hi && fk.every((fi) => x.fac[fi].has(st.f[fi])));
      const by = {
        low: (a, b) => a.price - b.price || a.i - b.i, high: (a, b) => b.price - a.price || a.i - b.i, off: (a, b) => b.off - a.off || a.i - b.i,
        az: (a, b) => a.name.localeCompare(b.name) || a.i - b.i, za: (a, b) => b.name.localeCompare(a.name) || a.i - b.i,
        new: (a, b) => b.date - a.date || a.i - b.i, old: (a, b) => a.date - b.date || a.i - b.i
      }[st.sort] || ((a, b) => a.i - b.i);
      list.sort(by);
      const on = new Set(list.slice(0, pages * size));
      list.forEach((x, k) => { const o = String(k); if (x.li.style.order !== o) x.li.style.order = o; });
      items.forEach((x) => setHidden(x.li, !on.has(x)));
      setHidden(more, list.length <= pages * size);
      setHidden(empty, list.length > 0);
      if (count) setText(count, (list.length === 1 ? root.dataset.one : (root.dataset.many || '')).replace('[count]', list.length));
      root.querySelectorAll('.c26g__sel select').forEach((x) => { const set = x.value !== (x.dataset.default || ''); const f = x.closest('.c26g__sel'); if (f && f.classList.contains('is-set') !== set) f.classList.toggle('is-set', set); syncSelect(x); });
    }
    pills.forEach((b) => b.addEventListener('click', () => {
      if (st.cat === catOf(b)) return;
      st.cat = catOf(b); pages = 1;
      pills.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      buildFacets(); apply();
    }));
    Object.keys(sels).forEach((k) => sels[k].addEventListener('change', () => { st[k] = sels[k].value; pages = 1; apply(); }));
    if (more) more.addEventListener('click', () => { pages++; apply(); });
    const reset = root.querySelector('[data-g-reset]');
    if (reset) reset.addEventListener('click', () => {
      if (!pillRow || !pillRow.hidden) st.cat = '';
      st.price = ''; st.sort = sortDefault; pages = 1;
      Object.values(sels).forEach((x) => { x.value = x === sels.sort ? sortDefault : ''; });
      pills.forEach((x) => x.setAttribute('aria-pressed', String(catOf(x) === st.cat)));
      buildFacets(); apply();
    });
    Object.values(sels).forEach(enhanceSelect);

    /* products per row: the shopper's last choice, kept on their device */
    const colBtns = [...root.querySelectorAll('[data-g-col]')];
    const setCols = (n, save) => {
      root.style.setProperty('--cols', n);
      colBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gCol === String(n))));
      if (save) try { localStorage.setItem('c26g-cols', String(n)); } catch (e) {}
    };
    if (colBtns.length) {
      let saved = null;
      try { saved = localStorage.getItem('c26g-cols'); } catch (e) {}
      if (saved && colBtns.some((b) => b.dataset.gCol === saved)) setCols(saved, false);
      colBtns.forEach((b) => b.addEventListener('click', () => setCols(b.dataset.gCol, true)));
    }
    buildFacets(); apply();
    root.classList.add('is-ready');
  }

  const boot = (scope) => (scope || document).querySelectorAll('[data-c26-grid]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true }); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
